// extracted by mini-css-extract-plugin
export default {"skewedBackground":"LoginBackground_skewedBackground__H2DoA","skewedBackgroundLines":"LoginBackground_skewedBackgroundLines__D6vx8"};